export default __webpack_public_path__ + "static/media/red-cross.634d92d6.webp";